import React from 'react';
import classnames from 'classnames';

import { RecipeBanner, RecipeDetails, RecipeIngredientsListWithBulkAdd } from 'components/recipe';
import {
  Breadcrumbs, Error, Responsive, Skeleton
} from 'components/ui';
import { APP_ROUTES } from 'constants/routes';
import { useRecipe } from '@hooks/data/useRecipe';

import styles from './RecipeDetailsTemplate.module.scss';

const BREADCRUMBS = [
  {
    href: APP_ROUTES.HOME,
    name: 'NAVIGATION.HOME',
    translate: true
  },
  {
    href: APP_ROUTES.RECIPES_LANDING,
    name: 'NAVIGATION.BLOG.RECIPES.DEFAULT',
    translate: true
  },
];

interface Props {
  className?: string,
  preview: boolean,
  slug: string
}

const RecipeDetailsTemplate = (props: Props) => {

  const {
    className,
    slug,
    preview
  } = props;

  const { data: recipe, isLoading, isError } = useRecipe({ slug, preview });

  if (isError) {
    return <Error />;
  }

  if (isLoading) {
    return <Skeleton count={3} />;
  }

  if (recipe) {
    const {
      details,
      media,
      label,
    } = recipe;

    const {
      title
    } = details || {};

    const {
      banner
    } = media || {};

    const {
      desktop: desktopBanner,
      mobile: mobileBanner,
    } = banner || {};

    // Render

    return (
      <div className={classnames(styles.root, className)}>

        {/* Breadcrumbs */}
        <Breadcrumbs
          className={styles.breadcrumbs}
          items={[
            ...BREADCRUMBS,
            {
              name: title,
              translate: false
            }
          ]}
        />

        {/* Banner */}
        <RecipeBanner
          className={styles.banner}
          banner={{
            desktop: desktopBanner,
            mobile: mobileBanner
          }}
          label={label}
        />

        {/* Content */}
        <div className={styles.content}>

          {/* Sidebar */}
          <Responsive
            mobile={null}
            desktop={(
              <div className={styles.sidebar}>
                <RecipeIngredientsListWithBulkAdd
                  recipe={recipe}
                />
              </div>
            )}
          />

          {/* Main */}
          <div className={styles.main}>
            <RecipeDetails
              recipe={recipe}
            />
          </div>

        </div>

      </div>
    );
  }

  return null;
};

export default RecipeDetailsTemplate;
